
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="App">
        <Header />
        <main>
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
